__webpack_require__.p = "https://google-workspace-mfe.digital.vpsvc.com/";